import React from 'react';

import PDF from "./PDFComponent";
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as tableActions from '../../../store/actions/table';


const PDFPage = (props) => {

    const judgeNumber = props.match.params.judge ? parseInt(props.match.params.judge) - 1 : 0;

    const events = props.events;
    if (!events) return null;
    const event = events.event;
    const round = events.competition.template.rounds["1"];
    var scores = round.scores[judgeNumber];

    let grade = events.competition.competition.grade;
    let comp = events.competition.competition;

    let ageTitle = '';

    for(var col of grade.columns){
        if (col.id.toString() === comp.column) {
            ageTitle = col.title;
        }
    }

    const competitionName = events.competition.competition.code + " - " +
        events.competition.competition.grade.title + " " +
        events.competition.competition.rowTitle + " " +
        ageTitle

    const titles = [
        event.name,
        competitionName
    ]

    const headers = [
        "Dancer",
        "Name",
        "School",
        "Final IP",
        "Final Rank",
        "Placed",
    ]

    let addedPlacedText = false;
    //console.log("Scores", scores);

    scores = scores.sort((a, b) => {
        return a["finalRank"] - b["finalRank"]
    })

    var content = [];

    let chunks = [];
    var i,j, temporary, chunk4 = 20;
    for (i = 0,j = scores.length; i < j; i += chunk4) {
        temporary = scores.slice(i, i + chunk4);
        chunks.push(temporary);
        // do whatever
    }

    //console.log("tem", chunks, scores);


    let tables = [];

    for(var chunk of chunks) {
        var content4 = chunk.map((score, i) => {
            let rel = events.competition.entries.filter(item => item._id === score.entryCompetition);
            //console.log("Rel", rel, events.competition.entries[i]);
            let s = {};

            if (rel.length > 0) {
                s = rel[0];
            }
            console.log("Score", score);
            return [
                s.dancerNumber ? s.dancerNumber : 0,
                s.dancer ? s.dancer.name + " " + (s.dancer.lname ? s.dancer.lname : "") : "",
                s.dancer ? s.dancer.school.name : "",
                score["finalIp"],
                score["finalRank"],
                score['wq'] ? "Y" : "N"
            ]
        });

        for(let c of content4) {
            let index = content4.indexOf(c);
            if (content[index] + 1) {
                if (c[5] === "Y" && content4[index + 1][5] === "N" && !addedPlacedText) {
                    console.log("C", c);
                    addedPlacedText = true;
                    content4.splice(index + 1, 0, ['Dancers below this line did not place']);
                }
            }
        }

        console.log("CONTENT", content4);


        tables.push({
            headers,
            content: content4
        });
    }

    const table = {
        headers,
        content
    }

    const pdfData = {
        table,
        tables,
        titles,
        image: props.events.competition.competition.grade.event.image.path,
    }


    console.log("PDF", pdfData);
    return (
        <div style={{ height: "100vh" }}>

            <PDF pdfData={pdfData} />
        </div>
    );
}

const mapStateToProps = state => ({
    auth: state.auth,
    table: state.table,
    user: state.user,
    events: state.events
});


const mapDispatchToProps = dispatch => ({
    getTableData: (view, skip, limit, sort, token, mode) => {
        dispatch(tableActions.getTableDataWithQuery(view, skip, limit, sort, {}, token, mode));
    },
    getTableDataWithQuery: (view, skip, limit, sort, query, token, mode) => {
        dispatch(tableActions.getTableDataWithQuery(view, skip, limit, sort, query, token, mode));
    },
});


const Connected = withRouter(connect(mapStateToProps, mapDispatchToProps)(PDFPage));

class PDFPageContainer extends React.Component {
    render() {
        return (
            <div>
                <Connected {...this.props} />
            </div>
        )
    }
}

export default PDFPageContainer;
